export const NAVIGATION_LINKS = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/about" },
  { name: "Jobs", href: "/jobs" },
  // { name: "Plans", href: "/plans" },
  { name: "Contact", href: "/contact" },
];
